
// import React, { useState } from 'react';

// const CommentForm = ({ 
//   postId, 
//   onSubmit, 
//   onCancel, 
//   parentComment = null, 
//   submitting = false 
// }) => {
//   const [formData, setFormData] = useState({
//     author: '',
//     email: '',
//     website: '',
//     content: ''
//   });
  
//   const [errors, setErrors] = useState({});

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
    
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!formData.author.trim()) {
//       newErrors.author = 'Le nom est obligatoire';
//     }
    
//     if (!formData.email.trim()) {
//       newErrors.email = 'L\'email est obligatoire';
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = 'Format d\'email invalide';
//     }
    
//     if (!formData.content.trim()) {
//       newErrors.content = 'Le commentaire ne peut pas être vide';
//     }
    
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     try {
//       const commentData = {
//         postId: postId, 
//         author: formData.author.trim(),
//         email: formData.email.trim(),
//         website: formData.website.trim(),
//         content: formData.content.trim(),
//         parentId: parentComment?.id || 0
//       };

//       await onSubmit(commentData);
      
//       // Réinitialiser le formulaire après soumission réussie
//       setFormData({
//         author: '',
//         email: '',
//         website: '',
//         content: ''
//       });
//       setErrors({});
      
//     } catch (error) {
//       console.error('Erreur lors de la soumission:', error);
//       setErrors({
//         submit: error.message || 'Une erreur est survenue lors de l\'envoi du commentaire'
//       });
//     }
//   };

// return (
//     <div className="bg-white rounded-lg border border-gray-200 p-6">
//       {parentComment && (
//         <div className="mb-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded">
//           <p className="text-sm text-gray-600 mb-1">
//             Réponse à <strong>{parentComment.author}</strong>:
//           </p>
//           <p className="text-sm text-gray-700 italic">
//             "{parentComment.content.substring(0, 100)}..."
//           </p>
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="space-y-4">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label htmlFor="author" className="block text-sm font-medium text-gray-700 mb-2">
//               Nom Complet*
//             </label>
//             <input
//               type="text"
//               id="author"
//               name="author"
//               value={formData.author}
//               onChange={handleInputChange}
//               className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
//                 errors.author ? 'border-red-500' : 'border-gray-300'
//               }`}
//               placeholder="Votre nom"
//               disabled={submitting}
//             />
//             {errors.author && (
//               <p className="mt-1 text-sm text-red-600">{errors.author}</p>
//             )}
//           </div>

//           <div>
//             <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
//               Email *
//             </label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               value={formData.email}
//               onChange={handleInputChange}
//               className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
//                 errors.email ? 'border-red-500' : 'border-gray-300'
//               }`}
//               placeholder="votre@email.com"
//               disabled={submitting}
//             />
//             {errors.email && (
//               <p className="mt-1 text-sm text-red-600">{errors.email}</p>
//             )}
//           </div>
//         </div>

//         <div>
//           <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-2">
//             Site web (optionnel)
//           </label>
//           <input
//             type="url"
//             id="website"
//             name="website"
//             value={formData.website}
//             onChange={handleInputChange}
//             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             placeholder="https://votre-site.com"
//             disabled={submitting}
//           />
//         </div>

//         <div>
//           <label htmlFor="content" className="block text-sm font-medium text-gray-700 mb-2">
//             Commentaire *
//           </label>
//           <textarea
//             id="content"
//             name="content"
//             rows={4}
//             value={formData.content}
//             onChange={handleInputChange}
//             className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
//               errors.content ? 'border-red-500' : 'border-gray-300'
//             }`}
//             placeholder="Écrivez votre commentaire..."
//             disabled={submitting}
//           />
//           {errors.content && (
//             <p className="mt-1 text-sm text-red-600">{errors.content}</p>
//           )}
//         </div>

//         {errors.submit && (
//           <div className="p-3 bg-red-50 border border-red-200 rounded-md">
//             <p className="text-sm text-red-600">{errors.submit}</p>
//           </div>
//         )}

//         <div className="flex items-center justify-end space-x-3">
//           {onCancel && (
//             <button
//               type="button"
//               onClick={onCancel}
//               className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium transition-colors"
//               disabled={submitting}
//             >
//               Annuler
//             </button>
//           )}
//           <button
//             type="submit"
//             disabled={submitting}
//             className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors"
//           >
//             {submitting ? 'Envoi...' : 'Publier le commentaire'}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default CommentForm;

import React, { useState } from 'react';
import { 
  CheckCircleIcon, 
  ExclamationTriangleIcon,
  ClockIcon 
} from '@heroicons/react/24/outline';

const CommentForm = ({ 
  postId, 
  onSubmit, 
  onCancel, 
  parentComment = null, 
  submitting = false 
}) => {
  const [formData, setFormData] = useState({
    author: '',
    email: '',
    website: '',
    content: ''
  });
  
  const [errors, setErrors] = useState({});
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.author.trim()) {
      newErrors.author = 'Le nom est obligatoire';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'L\'email est obligatoire';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Format d\'email invalide';
    }
    
    if (!formData.content.trim()) {
      newErrors.content = 'Le commentaire ne peut pas être vide';
    }
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const commentData = {
        postId: postId, 
        author: formData.author.trim(),
        email: formData.email.trim(),
        website: formData.website.trim(),
        content: formData.content.trim(),
        parentId: parentComment?.id || 0
      };

      await onSubmit(commentData);
      
      // Afficher le message de succès
      setShowSuccessMessage(true);
      
      // Réinitialiser le formulaire après soumission réussie
      setFormData({
        author: '',
        email: '',
        website: '',
        content: ''
      });
      setErrors({});
      
      // Masquer le message après 8 secondes
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 8000);
      
    } catch (error) {
      console.error('Erreur lors de la soumission:', error);
      setErrors({
        submit: error.message || 'Une erreur est survenue lors de l\'envoi du commentaire'
      });
    }
  };

  return (
    <div className="space-y-4">
      {/* Message de succès */}
      {showSuccessMessage && (
        <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-lg shadow-md animate-fade-in">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <CheckCircleIcon className="h-6 w-6 text-green-500" />
            </div>
            <div className="ml-3 flex-1">
              <h3 className="text-sm font-medium text-green-800">
                Commentaire envoyé avec succès !
              </h3>
              <div className="mt-2 text-sm text-green-700">
                <p className="flex items-center">
                  <ClockIcon className="h-4 w-4 mr-2" />
                  Votre commentaire sera publié une fois approuvé par un modérateur.
                </p>
              </div>
            </div>
            <button
              onClick={() => setShowSuccessMessage(false)}
              className="flex-shrink-0 ml-3 text-green-500 hover:text-green-700"
            >
              <span className="sr-only">Fermer</span>
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      )}

      <div className="bg-white rounded-lg border border-gray-200 p-6">
        {parentComment && (
          <div className="mb-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded">
            <p className="text-sm text-gray-600 mb-1">
              Réponse à <strong>{parentComment.author}</strong>:
            </p>
            <p className="text-sm text-gray-700 italic">
              "{parentComment.content.substring(0, 100)}..."
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="author" className="block text-sm font-medium text-gray-700 mb-2">
                Nom Complet *
              </label>
              <input
                type="text"
                id="author"
                name="author"
                value={formData.author}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  errors.author ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Votre nom"
                disabled={submitting}
              />
              {errors.author && (
                <p className="mt-1 text-sm text-red-600">{errors.author}</p>
              )}
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  errors.email ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="votre@email.com"
                disabled={submitting}
              />
              {errors.email && (
                <p className="mt-1 text-sm text-red-600">{errors.email}</p>
              )}
            </div>
          </div>

          <div>
            <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-2">
              Site web (optionnel)
            </label>
            <input
              type="url"
              id="website"
              name="website"
              value={formData.website}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="https://votre-site.com"
              disabled={submitting}
            />
          </div>

          <div>
            <label htmlFor="content" className="block text-sm font-medium text-gray-700 mb-2">
              Commentaire *
            </label>
            <textarea
              id="content"
              name="content"
              rows={4}
              value={formData.content}
              onChange={handleInputChange}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.content ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Écrivez votre commentaire..."
              disabled={submitting}
            />
            {errors.content && (
              <p className="mt-1 text-sm text-red-600">{errors.content}</p>
            )}
          </div>

          {/* Info sur la modération */}
          <div className="flex items-start p-3 bg-yellow-50 border border-yellow-200 rounded-md">
            <ExclamationTriangleIcon className="h-5 w-5 text-yellow-600 mr-2 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-yellow-800">
              <strong>Note:</strong> Tous les commentaires sont soumis à modération avant publication. 
              Vous serez notifié une fois votre commentaire approuvé.
            </p>
          </div>

          {errors.submit && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm text-red-600">{errors.submit}</p>
            </div>
          )}

          <div className="flex items-center justify-end space-x-3">
            {onCancel && (
              <button
                type="button"
                onClick={onCancel}
                className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium transition-colors"
                disabled={submitting}
              >
                Annuler
              </button>
            )}
            <button
              type="submit"
              disabled={submitting}
              className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors"
            >
              {submitting ? 'Envoi...' : 'Publier le commentaire'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CommentForm;